const CallStatus = Object.freeze({
    CUSTOMER_DROP_OFF: "Customer Drop off",
    RESCHEDULED: "Rescheduled",
    RING: "Ring",
    INITIATE: "Initiate",
    START: "Start",
    END: "End",
});

export default CallStatus